import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useDispatch } from 'react-redux'
import { SetApplicationRole } from '../actions/applicationRoleActions'
import { applicationRoles } from '../constants/actionTypes'

const CheckUserAccess = (props) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (window.location.href.toLowerCase().indexOf('consultant') > -1) {
      dispatch(SetApplicationRole(applicationRoles.CONSULTANT))
    } else {
      dispatch(SetApplicationRole(applicationRoles.CUSTOMER))
    }
  }, [])

  return <>{props.children}</>
}

function mapStateToProps(state) {
  return {
    isAuthenticated: state.authentication.isAuthenticated,
  }
}

export default connect(mapStateToProps)(CheckUserAccess)
